// ***************************************
// Definition of game token SceneBuilder
// ***************************************
import { _cheatsEnabled, inventoryController } from "../../game_theme/flow_fb/flowController";
import { tbContainer } from "../engine/tbContainer";
import { tbGame } from "../engine/tbGame";
import { tbGraphics } from "../engine/tbGraphics";
import { tbVector } from "../engine/tbVector";
import { tbKeyCodes } from "../framework/tbKeyCodes";
import { tgfGraphics } from "../framework/tgfGraphics";
import { LevelSettings, MiscSettings, CameraSettings, PowerUpSettings } from "../settings/Settings";
import { s_floating_platform, s_floating_platform2, s_floating_platform3, s_bg_blurred_20, s_bg_tower_2, s_bg_tower, s_bg, s_big_platform, s_cloud, s_fg_object_2, s_fg_object, s_floating_stackable_platform, s_grey_floating_stackable_platform, s_fog, s_fog_2, s_leaves_2, s_leaves, s_stones, s_small_platform, s_platform_stone, s_platform_stone_end_l, s_platform_stone_end_r } from "./AssetDefinitions/ImageDefinitions";
import { explosion_transition } from "./AssetDefinitions/SpineDefinitions";
import { playController } from "./gameController";
import { InventoryController } from "./InventoryController";
import { blockFactory, getContainerForLayer, Layer, SceneControllerState } from "./SceneController";
import { SpineEffect } from "./SpineEffect";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var ImageTable = {};
ImageTable["s_floating_platform"] = s_floating_platform;
ImageTable["s_floating_platform2"] = s_floating_platform2;
ImageTable["s_floating_platform3"] = s_floating_platform3;
ImageTable["s_bg_blurred_20"] = s_bg_blurred_20;
ImageTable["s_bg_tower_2"] = s_bg_tower_2;
ImageTable["s_bg_tower"] = s_bg_tower;
ImageTable["s_bg"] = s_bg;
ImageTable["s_big_platform"] = s_big_platform;
ImageTable["s_cloud"] = s_cloud;
ImageTable["s_fg_object_2"] = s_fg_object_2;
ImageTable["s_fg_object"] = s_fg_object;
ImageTable["s_floating_stackable_platform"] = s_floating_stackable_platform;
ImageTable["s_grey_floating_stackable_platform"] = s_grey_floating_stackable_platform;
ImageTable["s_fog"] = s_fog;
ImageTable["s_fog_2"] = s_fog_2;
ImageTable["s_leaves_2"] = s_leaves_2;
ImageTable["s_leaves"] = s_leaves;
ImageTable["s_stones"] = s_stones;
ImageTable["s_small_platform"] = s_small_platform;
ImageTable["s_platform_stone"] = s_platform_stone;
ImageTable["s_platform_stone_end_l"] = s_platform_stone_end_l;
ImageTable["s_platform_stone_end_r"] = s_platform_stone_end_r;
// The constructor for the SceneBuilder game token. 
export var SceneBuilder = function (levelIndex) {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.halfWidth = tgfGraphics.areaWidth / 2;
    this.halfHeight = tgfGraphics.areaHeight / 2;
    this.levelDataExtra = LevelSettings.levelList[levelIndex].levelExtra;
    this.camera = { "x": 0, "y": 0, "zoom": 1, "vx": 0, "vy": 0, "locked": true };
    this.cameraDragging = { "dx": 0, "dy": 0, "dzoom": 0 };
    this.cameraTrackImpact = { "x": 0, "y": 0 };
    this.cameraFriction = 0.9;
    this.cameraAnimation = true;
    this.cameraAnimationTimer = 0;
    this.cameraShake = 0;
    this.hasRemovedObstructions = false;
    this.cameraIndex;
    this.wasZoomedOut = false;
    this.cameraAfterShotAnimation = false;
    this._trackBird = false;
    this._panToSlingshot = false;
    this.shiftPressed = false;
    this.activePropsCheat = false;
    this.panLock = false;
    this.fingerOne = { x: 0, y: 0, touch: false, startX: 0, startY: 0 };
    this.fingerTwo = { x: 0, y: 0, touch: false, startX: 0, startY: 0 };
    this.main = new tbContainer(tgfGraphics.areaWidth, tgfGraphics.areaHeight);
    this.mainContainer = new tbContainer(tgfGraphics.areaWidth, tgfGraphics.areaHeight);
    this.panToDefault = false;
    this.skipPanningRequest = true;
    this.textureList = [];
    for (var i in ImageTable) {
        this.textureList.push(i);
    }
    tbGame.addToken(this);
    tbGame.addTokenTags(this, "play");
};
SceneBuilder.prototype.handleMouseWheel = function (delta, x, y, real) {
    if (playController.sceneControllerActivePopUps || !playController.inputEnabled) {
        return;
    }
    this.cameraAnimation = false;
    this.zoomCamera(this.camera.zoom * (1 + real * 0.0003));
    if (this.onReachSlingshot) {
        this.onReachSlingshot();
        this.onReachSlingshot = null;
    }
};
// handleAdd is called when the token is (re-) added to the game. 
SceneBuilder.prototype.handleAdd = function () {
    "use strict";
    this.imageClone();
    this.resetCamera();
};
SceneBuilder.prototype.imageClone = function () {
    "use strict";
    //BG
    this.s_bg = s_bg.clone();
    this.s_bg.setDimensions(tgfGraphics.areaWidth * 1.05, tgfGraphics.areaHeight * 1.05); // We stretch by a bit and offset by -10 pixels to fix a gap at the top of iOS devices -Sam
    this.s_bg.setPosition(this.s_bg.x - Math.floor(((tgfGraphics.areaWidth * 1.05) - tgfGraphics.areaWidth) / 2), this.s_bg.y - Math.floor(((tgfGraphics.areaHeight * 1.05) - tgfGraphics.areaHeight) / 2));
    this.s_bg.add();
    var extraData = this.levelDataExtra;
    this.islands = [];
    for (var a = 0; a < extraData["islands"].length; a++) {
        var isle = extraData["islands"][a];
        var islandImage = ImageTable[isle["texture"]].clone();
        var vx = isle["driftSpeed"] ? isle["driftSpeed"] : 0;
        var vy = isle["floatSpeed"] ? isle["floatSpeed"] : 0;
        var range = isle["driftRange"] ? isle["driftRange"] : [0, 9999];
        var fadeMargin = isle["fadeMargin"] ? isle["fadeMargin"] : 0;
        var wobble = isle["wobble"] ? isle["wobble"] : 0;
        islandImage.timer = 0;
        islandImage.setBlendmode(isle["blendMode"]);
        islandImage.setScale(isle["scale"], isle["scale"]);
        islandImage.setPosition(isle["x"], isle["y"]);
        this.islands.push({ "image": islandImage, "data": isle, "x": isle["x"], "y": isle["y"], "vx": vx, "vy": vy, "wobble": wobble, "range": range, "fadeMargin": fadeMargin });
    }
    //Background
    for (var a = 0; a < this.islands.length; a++) {
        if (this.islands[a]["data"]["depth"] > 0)
            this.mainContainer.addChild(this.islands[a]["image"]);
    }
    //Game structure
    this.mainContainer.addChild(playController.sceneController.levelContainer);
    this.mainContainer.addChild(playController.sceneController.slingshotRight.container);
    this.mainContainer.addChild(playController.sceneController.slingshotLeft.container);
    this.mainContainer.addChild(playController.sceneController.pigContainer);
    //Foreground
    for (var a = 0; a < this.islands.length; a++) {
        if (this.islands[a]["data"]["depth"] <= 0)
            this.mainContainer.addChild(this.islands[a]["image"]);
    }
    //Banners
    this.bannerContainer = new tbContainer();
    this.mainContainer.addChild(this.bannerContainer);
    //Effects
    this.mainContainer.addChild(playController.sceneController.container);
    this.main.addChild(this.mainContainer);
    //add everything
    this.main.add();
};
// handleRemove is called when the token is removed from the game.
SceneBuilder.prototype.handleRemove = function () {
    "use strict";
    //remove everything
    this.main.remove();
    this.s_bg.remove();
};
// handleBeginStep is called each step before processing other events.
SceneBuilder.prototype.handleBeginStep = function (timePassed) {
    "use strict";
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
SceneBuilder.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
    if (playController.sceneControllerActivePopUps || !playController.inputEnabled) {
        //do not allow the player to drag/zoom the camera when a popup is active
        return;
    }
    if (finger == 0) {
        this.fingerOne.touch = true;
        this.fingerOne.startX = x;
        this.fingerOne.startY = y;
    }
    if (finger == 1) {
        this.fingerTwo.touch = true;
        this.fingerTwo.startX = x;
        this.fingerTwo.startY = y;
    }
    // fix for bird ability stopping auto camera tracking
    if (this.skipPanningRequest) {
        this.skipPanningRequest = false;
    }
    else {
        this.cameraAnimation = false;
    }
    // store initial values to compute realtime delta's with respect to origin
    this.cameraDragging.x = this.camera.x;
    this.cameraDragging.y = this.camera.y;
    this.cameraDragging.zoom = this.camera.zoom;
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
SceneBuilder.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
    if (finger == 0)
        this.fingerOne.touch = false;
    if (finger == 1)
        this.fingerTwo.touch = false;
};
// handleKeyDown is called if the key with the given keyCode is pressed.
SceneBuilder.prototype.handleKeyDown = function (keyCode) {
    "use strict";
    if (!_cheatsEnabled) {
        return;
    }
    if (keyCode == tbKeyCodes.vkShift)
        this.shiftPressed = true;
    // should all be removed completely before release
    // stuff to move background objects
    if (this.blockToMove == undefined)
        this.blockToMove = 0;
    if (keyCode == tbKeyCodes.vk2)
        console.log("\"x\":" + this.camera.x.toFixed(4) + ", \"y\":" + this.camera.y.toFixed(4) + ", \"zoom\":" + this.camera.zoom.toFixed(4));
    if (keyCode == tbKeyCodes.vk1)
        this.camera.locked = !this.camera.locked;
    var changedTexture = false;
    if (keyCode == tbKeyCodes.vkY) {
        this.activePropsCheat = !this.activePropsCheat;
    }
    if (keyCode == tbKeyCodes.vkT) {
        var mousePos = tbGraphics.toLocal(playController.sceneController.levelContainer, new tbVector(playController.sceneController.fingerOne.x, playController.sceneController.fingerOne.y));
        var closestObject = null;
        for (var i = 0; i < playController.sceneController.levelBlocks.length; i++) {
            var e = playController.sceneController.levelBlocks[i];
            var distance = Math.sqrt((mousePos.x - e.x) * (mousePos.x - e.x) + (mousePos.y - e.y) * (mousePos.y - e.y));
            if (distance < 1) {
                e.destroy();
                break;
            }
        }
    }
    if (this.shiftPressed && keyCode == tbKeyCodes.vkF) {
        if (this.mainContainer.container.visible == false) {
            this.mainContainer.show();
            this.s_bg.show();
        }
        else {
            this.mainContainer.hide();
            this.s_bg.hide();
        }
    }
    if (this.shiftPressed && keyCode == tbKeyCodes.vkD && MiscSettings.levelExportMode === true) {
        var blocks = playController.sceneController.levelBlocks;
        var data = JSON.parse(JSON.stringify(playController.sceneController.levelData));
        for (var i = 0; i < blocks.length; i++) {
            // find in levelData, set positions/rotations
            for (var k in data.world) {
                if (data.world.hasOwnProperty(k)) {
                    if (k.toString()[0] === "j")
                        continue; // pass on the joint, we don't need it
                    if (blocks[i].id.toString() == data.world[k].uniqueID) {
                        var isPig = false;
                        if (data.world[k].id.indexOf("_ALLY") !== -1) {
                            data.world[k].id = data.world[k].id.replace("_ALLY", "");
                            isPig = true;
                        }
                        else if (data.world[k].id.indexOf("_ENEMY") !== -1) {
                            data.world[k].id = data.world[k].id.replace("_ENEMY", "");
                            isPig = true;
                        }
                        if (blocks[i].isPig) {
                            isPig = true;
                        }
                        data.world[k].x = blocks[i].x - playController.sceneController.offsetX;
                        data.world[k].y = blocks[i].y - playController.sceneController.offsetY;
                        data.world[k].z = blocks[i].z;
                        if (isPig) {
                            data.world[k].angle = playController.sceneController._origPigAngles["id_" + data.world[k]["uniqueID"]];
                        }
                        else {
                            data.world[k].angle = (blocks[i].angle * 180 / Math.PI);
                        }
                    }
                    else {
                        continue;
                    }
                }
            }
        }
        data["exportedFromGame"] = true;
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));
        var dlAnchorElem = document.createElement("a");
        dlAnchorElem.setAttribute("id", "downloadAnchorElem");
        dlAnchorElem.setAttribute("style", "display:none");
        dlAnchorElem.setAttribute("href", dataStr);
        dlAnchorElem.setAttribute("download", "scene.json");
        dlAnchorElem.click();
        return;
    }
    // Nuke
    if (this.shiftPressed && keyCode == tbKeyCodes.vkQ) {
        new SpineEffect(0, 0, explosion_transition, "explosion_transition_animation", getContainerForLayer(Layer.smokePuff));
        var length = playController.sceneController.levelBlocks.length;
        for (i = 0; i < length; i++) {
            var block = blockFactory("MISC_EXPLOSIVE_TNT", 10000000 + Math.floor(Math.random() * 1000000), playController.sceneController.levelBlocks[i].x, playController.sceneController.levelBlocks[i].y, 0, playController.sceneController.levelContainer);
            playController.sceneController.levelBlocks.push(block);
        }
        var length2 = playController.sceneController.levelBlocks.length;
        for (i = length; i < length2; i++) {
            playController.sceneController.levelBlocks[i].applyDamage(999999);
        }
    }
    // Q
    if (keyCode == tbKeyCodes.vkQ) {
        var mousePos = tbGraphics.toLocal(playController.sceneController.levelContainer, new tbVector(playController.sceneController.fingerOne.x, playController.sceneController.fingerOne.y));
        var blockyBlock = blockFactory("STONE_BLOCK_4X2", 10000000 + Math.floor(Math.random() * 1000000), mousePos.x, mousePos.y, 0, playController.sceneController.levelContainer);
        blockyBlock.featherFall = true;
        blockyBlock.invincible = true;
        blockyBlock.onFirstContact = function () {
            this.featherFall = false;
        };
        blockyBlock.createParticleEffect();
        playController.sceneController.levelBlocks.push(blockyBlock);
    }
    if (keyCode == tbKeyCodes.vkO) // O
     {
        playController.showWait();
    }
    //0
    if (keyCode == tbKeyCodes.vk0) {
        this.blockToMove = Math.min(this.islands.length - 1, this.blockToMove + 1);
        changedTexture = true;
    }
    //9
    if (keyCode == tbKeyCodes.vk9) {
        this.blockToMove = Math.max(0, this.blockToMove - 1);
        changedTexture = true;
    }
    var n = this.islands[this.blockToMove]["data"];
    var n2 = this.islands[this.blockToMove];
    if (changedTexture == true) {
        console.log("texture selected = {\"texture\":\"" + n["texture"] + "\", \"x\":" + n["x"].toFixed(1) + ", \"y\":" + n["y"].toFixed(1) + ", \"depth\":" + n["depth"].toFixed(2) + ", \"scale\":" + n["scale"].toFixed(4) + ", \"blendMode\":" + n["blendMode"] + "}");
    }
    // P
    if (keyCode == tbKeyCodes.vkP) {
        inventoryController._powerUpSlots = InventoryController._createDefaultPowerUps(inventoryController);
        YoutubeStorageManager.savePlayerData(["powerUps"], [InventoryController._modelToPersistentData(inventoryController._powerUpSlots, inventoryController._serverTimeDiff)], function (temp) {
            console.log("Reset your powerups!");
        }, function (error) {
            throw new Error("Error while saving powerup data on Server");
        });
    }
    // create new bg unit
    if (keyCode == tbKeyCodes.vkN) {
        var newIsland = { "texture": n["texture"], "x": n2.x + 1, "y": n2.y + 1, "depth": 0.00, "scale": n["scale"], "blendMode": 0 };
        var isle = newIsland;
        var islandImage = ImageTable[isle["texture"]].clone();
        var vx = isle["driftSpeed"] ? isle["driftSpeed"] : 0;
        var vy = isle["floatSpeed"] ? isle["floatSpeed"] : 0;
        var range = isle["driftRange"] ? isle["driftRange"] : [0, 9999];
        var fadeMargin = isle["fadeMargin"] ? isle["fadeMargin"] : 0;
        var wobble = isle["wobble"] ? isle["wobble"] : 0;
        islandImage.timer = 0;
        islandImage.setBlendmode(isle["blendMode"]);
        islandImage.setScale(isle["scale"], isle["scale"]);
        islandImage.setPosition(isle["x"], isle["y"]);
        var islandEntry = { "image": islandImage, "data": isle, "x": isle["x"], "y": isle["y"], "vx": vx, "vy": vy, "wobble": wobble, "range": range, "fadeMargin": fadeMargin };
        this.islands.push(islandEntry);
        this.mainContainer.addChild(this.islands[this.islands.length - 1]["image"]);
        this.blockToMove = this.islands.length - 1;
    }
    // change texture img
    if (keyCode == tbKeyCodes.vkComma || keyCode == tbKeyCodes.vkPeriod) { // arrow left or ,
        var currentTexture = n["texture"];
        var currentEntry = this.textureList.indexOf(currentTexture);
        var newEntry = currentEntry;
        if (keyCode == tbKeyCodes.vkComma)
            newEntry = Math.max(0, --newEntry);
        else
            newEntry = Math.min(this.textureList.length - 1, ++newEntry);
        var newTexture = this.textureList[newEntry] ? this.textureList[newEntry] : this.textureList[currentEntry];
        var newIslandImage = ImageTable[newTexture].clone();
        this.mainContainer.removeChild(this.islands[this.blockToMove]["image"]);
        n["texture"] = newTexture;
        this.islands[this.blockToMove]["image"] = newIslandImage;
        this.mainContainer.addChild(this.islands[this.blockToMove]["image"]);
        console.log(newTexture);
    }
    if (keyCode == tbKeyCodes.vkLeft)
        n2.x -= 0.2 * (this.shiftPressed ? 10 : 1);
    if (keyCode == tbKeyCodes.vkRight)
        n2.x += 0.2 * (this.shiftPressed ? 10 : 1);
    if (keyCode == tbKeyCodes.vkUp)
        n2.y -= 0.2 * (this.shiftPressed ? 10 : 1);
    if (keyCode == tbKeyCodes.vkDown)
        n2.y += 0.2 * (this.shiftPressed ? 10 : 1);
    if (keyCode == tbKeyCodes.vkOpenbracket)
        n["scale"] -= 0.005 * (this.shiftPressed ? 10 : 1);
    if (keyCode == tbKeyCodes.vkClosebracket)
        n["scale"] += 0.005 * (this.shiftPressed ? 10 : 1);
    if (keyCode == tbKeyCodes.vk8) {
        var fullString = "";
        for (var a = 0; a < this.islands.length; a++) {
            var j = this.islands[a]["data"];
            var x = this.islands[a].x;
            var y = this.islands[a].y;
            fullString += "{\"texture\":\"" + j["texture"] + "\", \"x\":" + x.toFixed(1) + ", \"y\":" + y.toFixed(1) + ", \"depth\":" + j["depth"].toFixed(2) + ", \"scale\":" + j["scale"].toFixed(4) + ", \"blendMode\":" + j["blendMode"] + "}";
            if (a < this.islands.length - 1)
                fullString += ",\n";
        }
        console.log(fullString);
    }
};
// handleKeyUp is called if the key with the given keyCode is released.
SceneBuilder.prototype.handleKeyUp = function (keyCode) {
    "use strict";
    if (!_cheatsEnabled) {
        return;
    }
    if (keyCode == tbKeyCodes.vkShift)
        this.shiftPressed = false;
};
// handleAlarm is called if a global alarm is reached.
SceneBuilder.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
SceneBuilder.prototype.handleSpecial = function (id, args) {
    "use strict";
};
SceneBuilder.prototype.zoomCamera = function (newValue) {
    // we have to move the camera since scaling is always done around the origin in the corner
    // also why this is a bloody function
    this.camera.x += this.camera.x * (newValue / this.camera.zoom - 1);
    this.camera.y += this.camera.y * (newValue / this.camera.zoom - 1);
    this.camera.zoom = newValue;
};
SceneBuilder.prototype._generateCameraPositionForSlingshot = function (otherSlingshot) {
    // Get the slingshot and return position adapted from that
    //if(!playController.sceneController) return null;
    var cam = this.camera;
    var slingshot = playController.sceneController.getSlingshot(otherSlingshot);
    if (slingshot && cam) {
        // TODO: ADD EXTRA DISTANCE
        var negativeExtraSpace = (otherSlingshot != playController.isInitiatingPlayer);
        var extraSpace = this.halfWidth / CameraSettings["extraSpaceDivider"];
        var slingshotX = -(slingshot.x * cam.zoom) + (negativeExtraSpace ? -extraSpace : extraSpace);
        //var slingshotY = (slingshot.y * cam.zoom) * -0.75;
        return {
            "x": slingshotX,
            "y": cam.y,
            "zoom": cam.zoom,
            "zoomSpeed": CameraSettings["birdClickZoomSpeed"],
            "panSpeed": CameraSettings["birdClickPanSpeed"],
            "keytime": CameraSettings["birdClickKeyTime"]
        };
    }
    else {
        return {
            "x": extraData["cameraDefault"].x,
            "y": cam.y,
            "zoom": extraData["cameraDefault"].zoom,
            "zoomSpeed": CameraSettings["birdClickZoomSpeed"],
            "panSpeed": CameraSettings["birdClickPanSpeed"],
            "keytime": CameraSettings["birdClickKeyTime"]
        };
    }
};
SceneBuilder.prototype.centerCameraY = function () {
    "use strict";
    var slingshot = playController.sceneController.getSlingshot();
    this.camera.y = -slingshot.y * this.camera.zoom;
};
// handleEndStep is called each step after processing other events (before draw).
SceneBuilder.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (this.activePropsCheat) {
        for (var i = 0; i < playController.sceneController.levelBlocks.length; i++) {
            var e = playController.sceneController.levelBlocks[i];
            if (e.isActive() == false) {
                if (e.image)
                    e.image.setAlpha(0.5);
            }
            else {
                if (e.image)
                    e.image.setAlpha(1);
            }
        }
    }
    var cam = this.camera;
    var extraData = null;
    if (playController && playController.sceneController) {
        extraData = this.levelDataExtra;
    }
    else {
        console.log("playController.sceneController was undefined! (SceneBuilder.handleEndStep)");
        return;
    }
    if (this.fingerOne.touch) {
        this.fingerOne.x = tbGame.touchX(0);
        this.fingerOne.y = tbGame.touchY(0);
    }
    if (this.fingerTwo.touch) {
        this.fingerTwo.x = tbGame.touchX(1);
        this.fingerTwo.y = tbGame.touchY(1);
    }
    // we don't recompute the original touch positions so we lock the camera into a panning mode
    // this pan mode lock will stay in place until both fingers are lifted
    // this fixes the camera snapping back to one finger should one release one finger earlier than the other
    if (this.fingerOne.touch && this.fingerTwo.touch)
        this.panLock = true;
    if (!this.fingerOne.touch && !this.fingerTwo.touch)
        this.panLock = false;
    if (playController.sceneController.state === SceneControllerState.REPLAYING) {
        if (this._panToSlingshot) {
            var targetCameraFrame = this._generateCameraPositionForSlingshot(true);
            targetCameraFrame.zoom = CameraSettings["shootZoom"];
            cam.x += targetCameraFrame["panSpeed"] * (targetCameraFrame.x - cam.x);
            this.zoomCamera(cam.zoom + targetCameraFrame["zoomSpeed"] * (targetCameraFrame.zoom - cam.zoom));
        }
        else if (this.panToDefault) {
            cam.x += CameraSettings.birdClickPanSpeed * (extraData.cameraDefault.x - cam.x);
            this.zoomCamera(cam.zoom + CameraSettings.birdClickZoomSpeed * (extraData.cameraDefault.zoom - cam.zoom));
        }
        else if (playController.sceneController.balls.length > 0 && !playController.sceneController.balls[playController.sceneController.balls.length - 1].isDead()) {
            var bird = playController.sceneController.balls[playController.sceneController.balls.length - 1];
            var birdX = bird.x * cam.zoom;
            var birdY = bird.y * cam.zoom;
            if (!bird.firstContact) {
                this.cameraTrackImpact.x = -birdX - cam.x;
                this.cameraTrackImpact.y = -birdY;
                cam.x += CameraSettings["birdTrackSmoothing"] * (this.cameraTrackImpact.x - cam.x);
                // zoom if we go out vertically
                if (Math.abs(-birdY - cam.y) > this.halfHeight - CameraSettings["birdZoomMargin"]) {
                    if (this.wasZoomedOut == false) {
                        this.wasZoomedOut = true;
                        this.originalZoom = cam.zoom;
                    }
                    cam.zoom += CameraSettings["birdZoomSmoothing"] * (cam.zoom * ((this.halfHeight - CameraSettings["birdZoomMargin"]) / Math.abs(-birdY - cam.y)) - cam.zoom);
                }
                else {
                    if (this.wasZoomedOut === true) {
                        if (cam.zoom < this.originalZoom) {
                            cam.zoom += CameraSettings["birdZoomSmoothing"] * (this.originalZoom - cam.zoom);
                        }
                        else {
                            this.wasZoomedOut = false;
                        }
                    }
                }
            }
            else {
                // again move horizontally, and zoom vertically, but this time around the bird
                cam.x += CameraSettings["birdTrackSmoothing"] * (this.cameraTrackImpact.x - cam.x);
                if (Math.abs(-birdX - cam.x) > this.halfWidth - CameraSettings["birdZoomMargin"]) {
                    cam.zoom += CameraSettings["birdZoomSmoothing"] * (cam.zoom * ((this.halfWidth - CameraSettings["birdZoomMargin"]) / Math.abs(-birdX - cam.x)) - cam.zoom);
                }
            }
        }
    }
    else if (playController.sceneController.state === SceneControllerState.POWERUP_AVAILABLE
        || playController.sceneController.state === SceneControllerState.POWERUP_APPLYING
        || playController.sceneController.state === SceneControllerState.CHANGE_POWERUP) {
        //this.zoomCamera((cam.zoom + CameraSettings["zoomRubberBanding"] * (extraData["cameraBounds"]["maxZoom"] - cam.zoom)) * 0.7);
        // cam.zoom = tbEase.easeInQuadratic(cam.zoom * 0.001, cam.zoom, (cam.zoom + CameraSettings["zoomRubberBanding"] * (extraData["cameraBounds"]["maxZoom"] - cam.zoom)) * 0.7, 0.35);
        // if(cam.zoom > ((cam.zoom + CameraSettings["zoomRubberBanding"] * (extraData["cameraBounds"]["maxZoom"] - cam.zoom)) * 0.7))
        // {
        //  cam.zoom = (cam.zoom + CameraSettings["zoomRubberBanding"] * (extraData["cameraBounds"]["maxZoom"] - cam.zoom)) * 0.7;
        // }
        cam.zoom += PowerUpSettings.powerUpBarAnims.panSpeed * ((extraData["cameraBounds"]["maxZoom"] * 0.65) - cam.zoom);
        this.centerCameraY();
        cam.x += PowerUpSettings.powerUpBarAnims.zoomSpeed * (0 - cam.x);
    }
    else if (this.cameraAnimation && this._panToSlingshot) {
        var targetCameraFrame = this._generateCameraPositionForSlingshot(false);
        targetCameraFrame.zoom = CameraSettings["shootZoom"];
        if (this.cameraAnimationTimer / 1000 > targetCameraFrame["keytime"]) {
            if (this.cameraAfterShotAnimation == false) { // checking if it comes from cameratoslingshot function, if yes don't change zoom
                // starting camera
                cam.x += targetCameraFrame["panSpeed"] * (targetCameraFrame.x - cam.x);
                if (Math.abs(targetCameraFrame.x - cam.x) < 5 && this.onReachSlingshot) {
                    this.onReachSlingshot();
                    this.onReachSlingshot = null;
                }
                this.zoomCamera(cam.zoom + targetCameraFrame["zoomSpeed"] * (targetCameraFrame.zoom - cam.zoom));
            }
            else {
                cam.x += targetCameraFrame["panSpeed"] * (targetCameraFrame.x - cam.x);
            }
        }
    }
    else if (!playController.isShooting && this.cameraAnimation && this._trackBird) {
        this.hasRemovedObstructions = false;
        // if there are birds and that bird is not broken
        if (playController.sceneController.balls.length > 0 && !playController.sceneController.balls[playController.sceneController.balls.length - 1].isDead()) {
            var bird = playController.sceneController.balls[playController.sceneController.balls.length - 1];
            var birdX = bird.x * cam.zoom;
            var birdY = bird.y * cam.zoom;
            if (!bird.firstContact) {
                this.cameraTrackImpact.x = -birdX - cam.x;
                this.cameraTrackImpact.y = -birdY;
                // don't move left; the bird starts all the way at the left of the screen
                // pan horizontally
                if (playController.isMirrored && this.cameraTrackImpact.x > cam.x ||
                    !playController.isMirrored && this.cameraTrackImpact.x < cam.x) {
                    cam.x += CameraSettings["birdTrackSmoothing"] * (this.cameraTrackImpact.x - cam.x);
                }
                // zoom if we go out vertically
                if (Math.abs(-birdY - cam.y) > this.halfHeight - CameraSettings["birdZoomMargin"]) {
                    if (this.wasZoomedOut == false) {
                        this.wasZoomedOut = true;
                        this.originalZoom = cam.zoom;
                    }
                    this.zoomCamera(cam.zoom + CameraSettings["birdZoomSmoothing"] * (cam.zoom * ((this.halfHeight - CameraSettings["birdZoomMargin"]) / Math.abs(-birdY - cam.y)) - cam.zoom));
                    //cam.zoom += CameraSettings["birdZoomSmoothing"] * (cam.zoom * ((this.halfHeight - CameraSettings["birdZoomMargin"]) / Math.abs(-birdY - cam.y)) - cam.zoom);
                }
                else {
                    if (this.wasZoomedOut === true) {
                        if (cam.zoom < this.originalZoom) {
                            this.zoomCamera(cam.zoom + CameraSettings["birdZoomSmoothing"] * (this.originalZoom - cam.zoom));
                            //cam.zoom += CameraSettings["birdZoomSmoothing"] * ( this.originalZoom - cam.zoom );
                        }
                        else {
                            this.wasZoomedOut = false;
                        }
                    }
                }
            }
            else {
                // again move horizontally, and zoom vertically, but this time around the bird
                cam.x += CameraSettings["birdTrackSmoothing"] * (this.cameraTrackImpact.x - cam.x);
                if (Math.abs(-birdX - cam.x) > this.halfWidth - CameraSettings["birdZoomMargin"]) {
                    cam.zoom += CameraSettings["birdZoomSmoothing"] * (cam.zoom * ((this.halfWidth - CameraSettings["birdZoomMargin"]) / Math.abs(-birdX - cam.x)) - cam.zoom);
                }
                else {
                    if (this.wasZoomedOut === true) {
                        if (cam.zoom < this.originalZoom) {
                            this.zoomCamera(cam.zoom + CameraSettings["birdZoomSmoothing"] * (this.originalZoom - cam.zoom));
                            //cam.zoom += CameraSettings["birdZoomSmoothing"] * ( this.originalZoom - cam.zoom );
                        }
                        else {
                            this.wasZoomedOut = false;
                        }
                    }
                }
            }
            // block tracking camera, design didn't want this
            // var actionX = 0;
            // var actionY = 0;
            // var actionBlockCount = 0;
            // 
            // for (var a = 0; a < playController.sceneController.levelBlocks.length; a++) {
            //  
            //  if (!playController.sceneController.levelBlocks[a] || !playController.sceneController.levelBlocks[a].body) continue;
            //  
            //  physics.getBodyData(playController.sceneController.levelBlocks[a].body, data);
            //  
            //  if (data.velocity.length() + data.angular_velocity > 0.2) {
            //      
            //      actionX += data.x;
            //      actionY += data.y;
            //      actionBlockCount++;
            //  }
            // }
            // if (actionBlockCount > 0) {
            //  
            //  cameraTargetX = -actionX / actionBlockCount;
            //  cameraTargetY = -actionY / actionBlockCount;
            // }
            // 
        }
    }
    else {
        if (playController.isShooting || playController.isSelectingBird) {
            // keep the slingshot visible, and give it some breathing room if the player starts dragging
            // it's important to have enough room for your mouse / finger to make a shot at full power
            var slingshot = playController.sceneController.getSlingshot();
            if (this.hasRemovedObstructions === false) {
                playController.sceneController.removeBlocksNearSlingshot();
                this.hasRemovedObstructions = true;
            }
            var slingshotX = slingshot.x * cam.zoom;
            //var slingshotY = slingshot.y * cam.zoom;
            var breathingRoom = CameraSettings["birdLaunchMargin"];
            var cameraMoved = false;
            if (Math.abs(-slingshotX - cam.x) > this.halfWidth - breathingRoom) {
                // cam.zoom += extraData["cameraBounds"].slingshotTrackSpeed * (cam.zoom * ((this.halfWidth - breathingRoom) / Math.abs(-slingshotX - cam.x)) - cam.zoom);
                var targetX = -slingshotX - cam.x > this.halfWidth - breathingRoom ? -slingshotX - breathingRoom : -slingshotX + breathingRoom;
                cam.x += CameraSettings["slingshotTrackSpeed"] * (targetX - cam.x);
                cameraMoved = true;
            }
            // if (Math.abs(-slingshotY - cam.y) > this.halfHeight - breathingRoom) {
            //  var targetY = -slingshotY - cam.y > this.halfWidth - breathingRoom ? -slingshotY - breathingRoom : -slingshotY + breathingRoom;
            //  cam.y += CameraSettings["slingshotTrackSpeed"] * (targetY - cam.y);
            //  cameraMoved = true;
            // }
            if (!cameraMoved) {
                playController.isSelectingBird = false;
            }
            if (this.onReachSlingshot) {
                this.onReachSlingshot();
                this.onReachSlingshot = null;
            }
        }
        else if (this.fingerOne.touch || this.fingerTwo.touch) {
            this._trackBird = false;
            this._panToSlingshot = false;
            if (this.onReachSlingshot) {
                this.onReachSlingshot();
                this.onReachSlingshot = null;
            }
            // sum both positions, if we got both fingers we divide by two to get the average finger position
            var fingersStartPosition = { x: 0, y: 0 };
            var fingersPosition = { x: 0, y: 0 };
            if (this.fingerOne.touch) {
                fingersStartPosition.x += this.fingerOne.startX;
                fingersStartPosition.y += this.fingerOne.startY;
                fingersPosition.x += this.fingerOne.x;
                fingersPosition.y += this.fingerOne.y;
            }
            if (this.fingerTwo.touch) {
                fingersStartPosition.x += this.fingerTwo.startX;
                fingersStartPosition.y += this.fingerTwo.startY;
                fingersPosition.x += this.fingerTwo.x;
                fingersPosition.y += this.fingerTwo.y;
            }
            if (this.fingerOne.touch && this.fingerTwo.touch) {
                fingersStartPosition.x /= 2;
                fingersStartPosition.y /= 2;
                fingersPosition.x /= 2;
                fingersPosition.y /= 2;
            }
            // pan with velocity by first computing velocity and then "teleporting" to the right position of the mouse / fingers
            if (!this.panLock || (this.fingerOne.touch && this.fingerTwo.touch)) {
                cam["vx"] += 0.5 * (this.cameraDragging.x + this.mirror(fingersPosition.x - fingersStartPosition.x) - cam.x);
                //cam.vy += 0.5 * (this.cameraDragging.y + (fingersPosition.y - fingersStartPosition.y) - cam.y);
                cam.x += (this.cameraDragging.x + this.mirror(fingersPosition.x - fingersStartPosition.x) - cam.x);
                //cam.y += 1 * (this.cameraDragging.y + (fingersPosition.y - fingersStartPosition.y) - cam.y);
            }
        }
        else {
            this.hasRemovedObstructions = false;
        }
        // zooming, original zoom * (current distance between your fingers / original finger distance)
        // note that scrolling also zooms, but that's handled in a scroll event
        if (this.fingerOne.touch && this.fingerTwo.touch) {
            var originalDistance = Math.sqrt(Math.pow(this.fingerOne.startX - this.fingerTwo.startX, 2) + Math.pow(this.fingerOne.startY - this.fingerTwo.startY, 2));
            var currentDistance = Math.sqrt(Math.pow(this.fingerOne.x - this.fingerTwo.x, 2) + Math.pow(this.fingerOne.y - this.fingerTwo.y, 2));
            this.zoomCamera(this.cameraDragging.zoom * (currentDistance / originalDistance));
            if (this.onReachSlingshot) {
                this.onReachSlingshot();
                this.onReachSlingshot = null;
            }
        }
    }
    cam.x += cam["vx"];
    cam.y += cam["vy"];
    // slow the kinetic panning
    cam["vx"] *= this.cameraFriction;
    cam["vy"] *= this.cameraFriction;
    // debug stuff, we can unlock the camera to ignore bounds
    if (cam.locked) {
        // zoom bounds
        if (cam.zoom < extraData["cameraBounds"]["minZoom"]) {
            this.zoomCamera(cam.zoom + CameraSettings["zoomRubberBanding"] * (extraData["cameraBounds"]["minZoom"] - cam.zoom));
        }
        else if (cam.zoom > extraData["cameraBounds"]["maxZoom"]) {
            this.zoomCamera(cam.zoom + CameraSettings["zoomRubberBanding"] * (extraData["cameraBounds"]["maxZoom"] - cam.zoom));
        }
        var slingshotLeft = playController.sceneController.getSlingshot(false);
        var slingshotRight = playController.sceneController.getSlingshot(true);
        var slingshotLeftX = (slingshotLeft.x * cam.zoom);
        var slingshotRightX = (slingshotRight.x * cam.zoom);
        var extraSpace = this.halfWidth / CameraSettings["extraSpaceDivider"];
        var minX = slingshotLeftX + extraSpace;
        var maxX = slingshotRightX - extraSpace;
        if (!playController.isInitiatingPlayer) {
            minX = slingshotRightX + extraSpace;
            maxX = slingshotLeftX - extraSpace;
        }
        var currentRubberBanding = 1 - (1 - CameraSettings["panRubberBanding"]) * this.camera.zoom * 0.15;
        // panning bounds
        if (cam.x < minX) {
            cam["vx"] /= 1.2;
            cam.x += currentRubberBanding * (minX - cam.x);
        }
        else if (cam.x > maxX) {
            cam["vx"] /= 1.2;
            cam.x += currentRubberBanding * (maxX - cam.x);
        }
    }
    // background objects
    for (var a = 0; a < this.islands.length; a++) {
        var depthFactor = this.islands[a]["data"]["depth"] / cam.zoom;
        var isle = this.islands[a];
        isle.x += isle["vx"];
        // isle.y += isle.vy;
        if (isle.x > isle["range"][1])
            isle.x = isle["range"][0];
        // if (isle.x < isle.range[0]) isle.x = isle.range[1];
        var targetAlpha = 1;
        // if (isle.x - isle.range[0] < isle.fadeMargin) targetAlpha = isle.x / isle.fadeMargin;
        // if (isle.range[0] - isle.x < isle.fadeMargin) targetAlpha = isle.x / isle.fadeMargin;
        // var margin = isle.fadeTimerMargin;
        // 
        // if (isle.timer < margin * isle.resetTimer) targetAlpha = isle.timer / (margin * isle.resetTimer);
        // if (isle.timer > (1 - margin) * isle.resetTimer) targetAlpha = 1 - ((isle.timer - (1 - margin) * isle.resetTimer) / (margin * isle.resetTimer));
        // 
        // targetAlpha = 1 / (1 + Math.exp(-10 * (targetAlpha - 0.5)));
        isle["image"].setPosition(isle.x - (cam.x * depthFactor), isle.y + Math.sin(isle.x * 0.05) * isle["wobble"] - (cam.y * depthFactor));
        isle["image"].setScale(isle["data"]["scale"], isle["data"]["scale"]);
        if (isle["data"]["depth"] < -1e-10) {
            isle["image"].setAlpha(targetAlpha * Math.max(0, Math.min(1, Math.abs(1 / isle["data"]["depth"]) * (1 - (cam.zoom - extraData["cameraBounds"]["minZoom"]) / (extraData["cameraBounds"]["maxZoom"] - extraData["cameraBounds"]["minZoom"])))));
        }
    }
    // make sure camera Y is centered
    this.centerCameraY();
    var shake = playController.sceneController.cameraShake * CameraSettings["cameraShake"]["intensity"];
    playController.sceneController.cameraShake *= CameraSettings["cameraShake"]["fade"];
    this.main.setScale(this.mirror(cam.zoom), cam.zoom);
    this.main.setPosition(this.mirror(cam.x) + this.halfWidth + shake * (Math.random() - 0.5), cam.y + this.halfHeight + shake * (Math.random() - 0.5));
};
SceneBuilder.prototype.resetCamera = function () {
    var extraData = this.levelDataExtra;
    this.camera.zoom = extraData["cameraDefault"]["zoom"];
    this.camera.x = extraData["cameraDefault"]["x"];
    this.camera.y = extraData["cameraDefault"]["y"];
};
// handleDraw is called at the end of a step to draw the token.
SceneBuilder.prototype.handleDraw = function () {
    "use strict";
};
SceneBuilder.prototype.mirror = function (scale) {
    "use strict";
    return playController.isMirrored ? -scale : scale;
};
SceneBuilder.prototype.trackBird = function () {
    'use strict';
    this._trackBird = true;
    this._panToSlingshot = false;
};
SceneBuilder.prototype.untrackBird = function () {
    'use strict';
    this._trackBird = false;
};
SceneBuilder.prototype.cameraToSlingshot = function (shouldZoom, onReachSlingshot) {
    "use strict";
    this._panToSlingshot = true;
    this._trackBird = false;
    var extraData = this.levelDataExtra;
    this.cameraAnimation = true;
    this.cameraIndex = extraData["cameraAnimation"].length - 1;
    this.cameraAfterShotAnimation = !shouldZoom;
    this.cameraTrackImpact = { "x": 0, "y": 0 };
    this.cameraAnimationTimer = extraData["cameraAnimation"][this.cameraIndex]["keytime"] * 1000;
    if (onReachSlingshot) {
        this.onReachSlingshot = onReachSlingshot;
    }
};
